import { FlexCol } from '../../../components/Flex'

import { BossProvider } from '../../../context'
import CustomBasePage from '../../../CustomBasePage'
import GeominesList from './List'

const GeominesPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <BossProvider>
      <CustomBasePage>
        <FlexCol marginY={2} alignItems="stretch">
          <GeominesList />
        </FlexCol>
      </CustomBasePage>
    </BossProvider>
  )
}

export default GeominesPage
